import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';

import './SrMarketPropertyPhotos.less';

export const SR_MARKET_PROPERTY_PHOTOS_THEME_ADOBE = 'SR_MARKET_PROPERTY_PHOTOS_THEME_ADOBE';
const SR_MARKET_PROPERTY_PHOTOS_THEME_TO_CLASSNAME_MAPPING = {
  [SR_MARKET_PROPERTY_PHOTOS_THEME_ADOBE]: 'srMarketPropertyPhotosThemeAdobe',
};
const SR_MARKET_PROPERTY_PHOTOS_THEMES = Object.keys(SR_MARKET_PROPERTY_PHOTOS_THEME_TO_CLASSNAME_MAPPING);

const SrMarketPropertyPhotos = ({ photos, address, theme }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div
        styleName={classnames(
          SR_MARKET_PROPERTY_PHOTOS_THEME_TO_CLASSNAME_MAPPING[theme]
        )}
      >
        {photos.length > 0 ? (
          <div styleName='photosContainer'>
            {[0, 1, 2].map((index) => (
              <Fragment key={index}>
                <div
                  styleName={classnames('photoCard', {
                    active: photos.length > index,
                  })}
                  onClick={() => photos.length > index && setShowModal(true)}
                >
                  {photos.length > index && (
                    <img src={photos[index]} alt='listing' />
                  )}
                  {index === 2 && photos.length > 3 && (
                    <div styleName='overlay'>
                      <span>
                        See all <br /> {photos.length} photos
                      </span>
                    </div>
                  )}
                </div>
              </Fragment>
            ))}
          </div>
        ) : (
          <div styleName='noPhotosContainer'>
            <span styleName='noPhotosText'>
              No photos found on Sunroom
            </span>
          </div>
        )}
      </div>
      {showModal && (
        <SrDarkModal onClose={() => setShowModal(false)}>
          <SrModalContent>
            <div styleName='content'>
              <p> <b>Current Photos for</b> {address} </p>
              <div styleName='verticalScroller'>
                {photos.map((photo) => (
                  <img
                    key={photo}
                    styleName={classnames({ alone: photos.length === 1 })}
                    src={photo}
                    alt='listing'
                  />
                ))}
              </div>
            </div>
          </SrModalContent>
        </SrDarkModal>
      )}
    </>
  );
};

SrMarketPropertyPhotos.propTypes = {
  photos: PropTypes.array.isRequired,
  address: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(SR_MARKET_PROPERTY_PHOTOS_THEMES),
};

SrMarketPropertyPhotos.displayName = 'SrMarketPropertyPhotos';

export default SrMarketPropertyPhotos;
